import { EMPTY_OBJECT } from '../../../constants/common'
import { EntityProfileHeaderMoreButton } from '../../Entity'

import { UserProfileHeaderFooterSkeleton } from './UserProfileHeaderFooterSkeleton'

import * as styles from './UserProfileHeaderFooter.module.css'

function UserProfileHeaderFooter({
  PrimaryAction = null,
  SecondaryAction = null,
  actionHandlers = EMPTY_OBJECT,
  actionsConfig = EMPTY_OBJECT,
  getUploadFileInputProps,
  isLoading,
  moreButtonQaName,
}) {
  const { addNewOptions, moreOptions, primaryAction, secondaryAction } =
    actionsConfig

  function handleSelectOption({ value }) {
    actionHandlers[value]?.()
  }

  return isLoading ? (
    <UserProfileHeaderFooterSkeleton />
  ) : (
    <>
      <div className={styles.footer}>
        {PrimaryAction ? (
          <PrimaryAction
            actionHandlers={actionHandlers}
            addNewOptions={addNewOptions}
            primaryAction={primaryAction}
            onSelectOption={handleSelectOption}
          />
        ) : null}

        {SecondaryAction ? (
          <SecondaryAction
            actionHandlers={actionHandlers}
            secondaryAction={secondaryAction}
          />
        ) : null}

        {moreOptions?.length > 0 ? (
          <EntityProfileHeaderMoreButton
            buttonProps={{
              qaName: moreButtonQaName,
            }}
            dropdownFloatingConfig={{ maxWidthByRef: false }}
            options={moreOptions}
            onSelectItem={handleSelectOption}
          />
        ) : null}
      </div>

      {getUploadFileInputProps ? (
        <input {...getUploadFileInputProps()} />
      ) : null}
    </>
  )
}

export default UserProfileHeaderFooter
